module.exports = __webpack_public_path__ + "media/AMF.d3212694.mp4";